import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Person } from '../../../user/model/Person';
import {Dialog} from '../../../global/util/Dialog';
import {InformType} from '../../../global/util/enum/InformType';

@Component({
  selector: 'app-signed-document-viewer',
  templateUrl: './person-data-confirmation.component.html',
  styleUrls: ['./person-data-confirmation.component.css']
})
export class PersonDataConfirmationComponent implements OnInit {
  public reloadingPdf = false;
  public personId: number;
  public hashIdentifier: string;
  public selectedSignatureDescriptions: any[] = [];
  public signatureDescriptions: any[] = [];
  public person: Person;
  public document: Document;
  public loading: boolean;
  public alertType: string;
  public messageAlert: any;
  public icon: string;

  public acceptTermsConditions = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private route: Router
  ) {
    this.receiveParams();
  }

  ngOnInit(): void {}

  public receiveParams() {
    this.activatedRoute.params.subscribe(params => {
      this.hashIdentifier = params.hashIdentifier;
      this.personId = +params.personId;
    });

    this.document = history.state.document;
    this.person = history.state.person;

    if (!this.document) {
      this.navigatePrincipalUrl();
    }
  }

  change(event: any): void {
    this.acceptTermsConditions = event.target.checked;
  }

  continueProcess(): void {
    if (!this.acceptTermsConditions) {
      Dialog.show(InformType.Warning, '', 'Debe confirmar sus datos para continuar.');
      return;
    }

    this.navigateNextScreen(this.hashIdentifier, this.personId, 'viewer');
  }

  private navigatePrincipalUrl() {
    this.navigateNextScreen(this.hashIdentifier, this.personId, 'sign');
  }

  /**
   * Este método recibe paramatros para navegar entre pantallas.
   */
  private navigateNextScreen(hashIdentifier: any, personId: any, nameUrl: any) {
    this.route.navigate(['document/' + hashIdentifier + '/people/' + personId + '/' + nameUrl + '/'], {
      state: {
        document: this.document,
        person: this.person
      }
    }).then();
  }
}
